<ng-container *ngIf="!!element">
  <div class="field-container title">
    <mat-form-field class="title">
      <input [(ngModel)]="getTitleField().title" matInput placeholder="{{'general.title' | translate}}">
    </mat-form-field>
    <div class="error" *ngIf="titleError">{{'dynamicContent.openHours.errors.title' | translate}}</div>
  </div>
  <div class="dates" *ngIf="data.type !== 'regular'">
    <div class="field-container">
      <mat-form-field class="minimize-height">
        <mat-label>{{'dynamicContent.' + (data.type === 'span' ? 'startDate' : 'date') | translate}}</mat-label>
        <input [(ngModel)]="element.startDate" [matDatepicker]="startPicker" [max]="element.endDate" matInput>
        <mat-datepicker-toggle [for]="startPicker" matPrefix>
          <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      <div class="error" *ngIf="startDateError">{{'dynamicContent.openHours.errors.startDate' | translate}}</div>
    </div>
    <div class="field-container" *ngIf="data.type === 'span'">
      <mat-form-field class="minimize-height">
        <mat-label>{{'dynamicContent.endDate' | translate}}</mat-label>
        <input [(ngModel)]="element.endDate" [matDatepicker]="endPicker" [min]="element.startDate" matInput>
        <mat-datepicker-toggle [for]="endPicker" matPrefix>
          <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
      <div class="error" *ngIf="endDateError">{{'dynamicContent.openHours.errors.endDate' | translate}}</div>
    </div>
  </div>

  <ng-container *ngIf="data.type !== 'day'">
    <div class="weekdays">
      <div *ngFor="let day of element.days" class="weekday">
        <ibex-checkbox [checked]="day.open" (click)="initDay(day, $event.val)" [title]="('dynamicContent.openHours.' + day.day | translate) + ' - ' + ('dynamicContent.openHours.' + (day.open ? 'open' : 'closed') | translate)"></ibex-checkbox>
        <ibex-checkbox *ngIf="day.open" [checked]="day?.openFullDay" (click)="day.openFullDay = !day.openFullDay" [title]="'dynamicContent.openHours.openFullDay' | translate"></ibex-checkbox>
        <div class="times" *ngIf="!!day.open && !day?.openFullDay">
          <div *ngFor="let time of day.times; let i = index" class="time">
            <mat-form-field class="minimize-height">
              <mat-label>{{'dynamicContent.startTime' |translate}}</mat-label>
              <input [(ngModel)]="day.times[i].startTime" matInput readonly>
              <button (click)="openTimePicker(day, i, 'startTime')" mat-icon-button matPrefix>
                <mat-icon>access_time</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field class="minimize-height">
              <mat-label>{{'dynamicContent.endTime' |translate}}</mat-label>
              <input [(ngModel)]="day.times[i].endTime" matInput readonly>
              <button (click)="openTimePicker(day, i, 'endTime')" mat-icon-button matPrefix>
                <mat-icon>access_time</mat-icon>
              </button>
            </mat-form-field>
            <button *ngIf="i === 0" class="ibexfusion-icon-button" mat-icon-button (click)="addTime(day)">
              <mat-icon>add</mat-icon>
            </button>
            <button *ngIf="i !== 0" class="ibexfusion-icon-button" mat-icon-button (click)="removeTime(day, i)">
              <mat-icon>remove</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="error" *ngIf="sameTimeError">{{'dynamicContent.openHours.errors.sameTime' | translate}}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="data.type === 'day'">
    <div class="weekday">
      <ibex-checkbox [checked]="element.open" (click)="initElement($event.val)" [title]="'dynamicContent.openHours.' + (element.open ? 'open' : 'closed') | translate"></ibex-checkbox>
      <ibex-checkbox *ngIf="element.open" [checked]="element?.openFullDay" (click)="element.openFullDay = !element.openFullDay" [title]="'dynamicContent.openHours.openFullDay' | translate"></ibex-checkbox>
      <div class="times" *ngIf="!!element.open && !element?.openFullDay">
        <div *ngFor="let time of element.times; let i = index" class="time">
          <mat-form-field class="minimize-height">
            <mat-label>{{'dynamicContent.startTime' |translate}}</mat-label>
            <input [(ngModel)]="element.times[i].startTime" matInput readonly>
            <button (click)="openTimePicker(element, i, 'startTime')"  mat-icon-button matPrefix>
              <mat-icon>access_time</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field class="minimize-height">
            <mat-label>{{'dynamicContent.endTime' |translate}}</mat-label>
            <input [(ngModel)]="element.times[i].endTime" matInput readonly>
            <button (click)="openTimePicker(element, i, 'endTime')" mat-icon-button matPrefix>
              <mat-icon>access_time</mat-icon>
            </button>
          </mat-form-field>
          <button *ngIf="i === 0" class="ibexfusion-icon-button" mat-icon-button (click)="addTime(element)">
            <mat-icon>add</mat-icon>
          </button>
          <button *ngIf="i !== 0" class="ibexfusion-icon-button" mat-icon-button (click)="removeTime(element, i)">
            <mat-icon>remove</mat-icon>
          </button>
        </div>
        <div class="error" *ngIf="sameTimeError">{{'dynamicContent.openHours.errors.sameTime' | translate}}</div>
      </div>
    </div>
  </ng-container>

  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
  </div>
</ng-container>
